import { render, staticRenderFns } from "./ToolbarTextarea.vue?vue&type=template&id=453c68ad"
import script from "./ToolbarTextarea.vue?vue&type=script&lang=js"
export * from "./ToolbarTextarea.vue?vue&type=script&lang=js"
import style0 from "./ToolbarTextarea.vue?vue&type=style&index=0&id=453c68ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports